module.exports = __webpack_public_path__ + "static/glance3.aa3f25cf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/glance3.gif
// module id = 1356
// module chunks = 94883237073720 175223062182307